module.exports = __webpack_public_path__ + "assets/img/footer-open-963eaa75.png";